// removed by extract-text-webpack-plugin
module.exports = {"title-social":"title-social","list-socia":"list-socia","item":"item","fa-facebook-f":"fa-facebook-f","fa-twitter":"fa-twitter","fa-google-plus":"fa-google-plus","fa-youtube":"fa-youtube","fa-instagram":"fa-instagram","fa-pinterest-p":"fa-pinterest-p"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-footer/_ListSocial.scss
// module id = ./components/layouts/master/sub-footer/_ListSocial.scss
// module chunks = 0